import { Dialog, DialogPanel, Transition } from '@headlessui/react';
import React, { Fragment, useEffect, useRef, useState } from 'react'

export default function MenuModal({ menu, setMenu, width = "tw-w-72" }) {
    const menuRef = useRef();
    const [menuStyle, setMenuStyle] = useState({});
    const [show, setShow] = useState(null);

    useEffect(() => {
        setShow((!menu || !menu.position) ? null : { changed: new Date() });
    }, [menu?.position?.x, menu?.position?.y])

    useEffect(() => {
        if (!menuRef.current || !show) {
            return;
        }

        const { innerWidth, innerHeight } = window;
        const { offsetWidth, offsetHeight } = menuRef.current;

        let x = menu.position.x || 0;
        let y = menu.position.y || 0;

        if (x > innerWidth * .615) x = innerWidth * .615;
        if (y + offsetHeight > innerHeight) y = innerHeight - offsetHeight - 5;

        setMenuStyle({ left: `${x}px`, top: `${y}px` });
    }, [show?.changed])

    const handleMenuButtonClick = (e, menuButton) => {
        menuButton.onClick();
        setMenu(null);
    }

    const handleClose = () => {
        setMenu(null);
    }

    if (!show)
        return <></>

    return (
        <Transition.Root show={!!show} as={Fragment}>
            <Dialog
                as="div"
                className="tailwind-preflight"
                open={!!show}
                onClose={handleClose}
            >
                <div
                    ref={menuRef}
                    className="tw-absolute tw-z-50 tw-border tw-border-gray-300 tw-rounded-md tw-bg-white tw-shadow-xl"
                    style={menuStyle}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="tw-ease-out tw-duration-300"
                        enterFrom="tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95"
                        enterTo="tw-opacity-100 tw-translate-y-0 sm:tw-scale-100"
                        leave="tw-ease-in tw-duration-200"
                        leaveFrom="tw-opacity-100 tw-translate-y-0 sm:tw-scale-100"
                        leaveTo="tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95"
                    >
                        <DialogPanel className="tw-divide-y tw-divide-gray-100">
                            <div
                                role="menu"
                                className={`tw-flex tw-flex-col tw-divide-y tw-divide-gray-100 ${width}`}>
                                {menu?.items?.map((group, index) => (
                                    <div key={index} className="tw-flex tw-flex-col tw-py-1">
                                        {group.map((menuButton) => (
                                            <MenuItem
                                                key={menuButton.label}
                                                label={menuButton.label}
                                                icon={menuButton.icon}
                                                disabled={menuButton.disabled}
                                                onClick={(e) => handleMenuButtonClick(e, menuButton)}
                                            />
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </DialogPanel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

const MenuItem = ({ label, icon, disabled = false, onClick }) => {
    const isDisabled = typeof disabled === "function"
        ? disabled()
        : !!disabled;

    return (
        <button
            type="button"
            className="tw-group tw-flex tw-items-center tw-px-3 tw-py-2 tw-text-sm tw-text-gray-700 
            hover:tw-bg-gray-100 hover:tw-text-gray-900 focus:tw-bg-gray-100 focus:tw-text-gray-900
            disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
            disabled={isDisabled}
            onClick={onClick}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    onClick();
                }
            }}
        >
            {icon && (
                <div className="tw-mr-3 tw-h-5 tw-w-5 tw-text-gray-400 group-hover:tw-text-gray-500">
                    {icon}
                </div>
            )}
            <span className="">{label}</span>
        </button>
    )
}
